module.exports = __webpack_public_path__ + "assets/img/my-bg.95e2b795.png";